var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"purpose-banner",style:(_vm.bgStyle)},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',{staticClass:"title-quienes-somos"},[_vm._v(" Únete al "),_c('br'),_vm._v(" equipo ")]),_c('p',{staticClass:"description-quienes-somos"},[_vm._v(" Postula a la posición que más te guste, nosotros/as te capacitaremos y así iniciarás tu carrera ")])])
}]

export { render, staticRenderFns }